import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PageShell } from "../components/layout/PageShell";
import { WORK_HUB } from "../data/siteContent";

export default function TheWorkHub() {
  return (
    <PageShell>
      <section data-testid="work-hub" className="relative pt-36 md:pt-44 pb-24 overflow-hidden grain">
        <div className="aurora-weave" />
        <div className="line-weave" />
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
          <div className="max-w-3xl mb-16">
            <p className="text-sm tracking-[0.24em] uppercase text-[#E7CC86]/80 mb-4">{WORK_HUB.eyebrow}</p>
            <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-cream mb-5">
              Where the work <span className="text-gold">meets you.</span>
            </h1>
            <p className="text-lg text-cream/70 max-w-2xl">{WORK_HUB.sub}</p>
          </div>

          <div className="space-y-6">
            {WORK_HUB.pathways.map((p, i) => {
              const flip = i % 2 === 1;
              return (
                <motion.div key={p.key}
                  initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
                  className="grid lg:grid-cols-2 gap-8 items-center glass rounded-3xl overflow-hidden group">
                  <div className={`relative h-64 lg:h-[26rem] ${flip ? "lg:order-2" : ""}`}>
                    <img loading="lazy" src={p.img} alt={p.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#0B1020]/55 to-transparent" />
                  </div>
                  <div className={`p-8 lg:p-14 ${flip ? "lg:order-1" : ""}`}>
                    <p className="text-sm tracking-[0.2em] uppercase text-[#E7CC86] mb-3">{p.kicker}</p>
                    <h2 className="font-display font-semibold text-3xl lg:text-5xl text-cream mb-3">{p.title}</h2>
                    <p className="text-[#E7CC86]/70 font-serif italic text-lg mb-4">{p.who}</p>
                    <p className="text-lg text-cream/70 leading-relaxed mb-8 max-w-lg">{p.body}</p>
                    <Link to={p.to} data-testid={`work-hub-cta-${p.key}`}
                      className="group/btn inline-flex items-center gap-3 btn-gold px-7 py-3.5 rounded-full font-semibold">
                      Explore <ArrowRight size={20} className="group-hover/btn:translate-x-1.5 transition-transform" />
                    </Link>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
